/* ==========================================================================
   SearcherFlightHotel > Autocomplete
   ========================================================================== */

/* Modules */
const AutocompleteClient = require('@bluekiri/alexandria-contrib-components/components/autocomplete/client/js');
const config = require('./config');
const { validationOrigin, validateLocation } = require('./validation');

/* Init  */
function initAutocomplete(selector, instance, configuration) {
    /* Instance references */
    const result = [];

    instance.element.querySelectorAll(`${selector} [data-component="Autocomplete"]`).forEach((item, index) => {
        /* Push autocomplete */
        result.push(
            AutocompleteClient(
                `${selector} [data-component="Autocomplete"][data-type="${config().type.autocomplete}-${index}"]`,
                configuration
            )
        );
    });

    result[0].config.onChange = [
        function fn() {
            validationOrigin(instance);
            onChangeOrigin(instance);
        }
    ];

    result[1].config.onChange = [
        function fn() {
            validateLocation(instance);
        }
    ];

    return result;
}

function onChangeOrigin(instance) {
    instance.location[1].input.getInput().focus();
    if (instance.location[1].value !== undefined && instance.location[1].value !== '') {
        operativeEventCallback(instance);
        discountsEventCallback(instance);
    }
}

function operativeEventCallback(instance) {
    const event = CustomEvent('routeChangeOperative', {
        detail: { instance }
    });
    document.dispatchEvent(event);
}

function discountsEventCallback(instance) {
    const event = CustomEvent('destinationChangeDiscounts', {
        detail: { instance }
    });
    document.dispatchEvent(event);
}

module.exports = {
    initAutocomplete
};
